var app = angular.module('leonardo');

var AccountName = function (AuthDataService) {
  return function (pk) {
    var label = '';
    angular.forEach(AuthDataService.authData.accountsManager, function(account) {
      if (account.id == pk) {
        label = account.name;
      }
    });
    return label;
  };
};

app.filter('accountName', ['AuthDataService', AccountName]);
